export * from './LightingEditor';
export { default } from './LightingEditor';
